import { t } from "../i18n";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errorMessage } from "../api/client";
import { useAuth } from "./useAuth";
import { Dialog } from "../ui/Dialog";

interface Start { code: string; url: string; expiresInMinutes: number }

/**
 * WhatsApp numara doğrulaması (ücretsiz katman; sunucu `phoneRequired` der). Ters akış: kullanıcı kodu işletme numarasına
 * gönderir (telefonda bağlantı, masaüstünde QR). Doğrulanınca /me yoklaması pencereyi kendiliğinden kapatır.
 * KVKK: numara Meta üzerinden geçtiği için yurt dışına aktarım açık rızası istenir.
 */
export function PhoneGate(): JSX.Element | null {
  const required = useAuth((s) => s.phoneRequired);
  const refresh = useAuth((s) => s.refresh), logout = useAuth((s) => s.logout);
  const [consent, setConsent] = useState(false);
  const [start, setStart] = useState<Start | null>(null);
  const [qr, setQr] = useState<string | null>(null);
  const [err, setErr] = useState<string>();
  useEffect(() => {
    if (!required || !start) return;
    const id = window.setInterval(() => void refresh(), 3000);
    return () => window.clearInterval(id);
  }, [required, start, refresh]);
  useEffect(() => {
    if (!start) return;
    void import("qrcode").then((q) => q.toDataURL(start.url, { margin: 1, width: 180 })).then(setQr).catch(() => setQr(null));
  }, [start]);
  if (!required) return null;
  const begin = async (): Promise<void> => {
    setErr(undefined);
    try { const s = await api<Start>("POST", "/verify/whatsapp/start"); setStart(s); window.open(s.url, "_blank", "noopener"); }
    catch (e) { setErr(errorMessage(e)); }
  };
  return (
    <Dialog open onClose={() => undefined} label={t("Telefon doğrulaması")} width={480}
      footer={<><Link to="/planlar" className="cad-btn-box">{t("Planları gör")}</Link><button type="button" className="cad-btn-box" onClick={() => void logout()}>{t("Çıkış")}</button></>}>
      <p>{t("Ücretsiz hesapta proje kaydetmek için telefon numaranızı WhatsApp ile doğrulayın. Her numara yalnız bir hesapta kullanılabilir; abonelerden doğrulama istenmez.")}</p>
      {!start ? (<>
        <label className="flex items-start gap-2 text-[11px]"><input type="checkbox" className="mt-0.5" checked={consent} onChange={(e) => setConsent(e.target.checked)} />
          <span>{t("Doğrulama mesajının WhatsApp (Meta) üzerinden, yurt dışındaki sunucularda işlenmesine ve numaramın hesap tekliği için saklanmasına açık rıza veriyorum.")} <Link to="/gizlilik" className="underline">{t("Gizlilik bildirimi")}</Link></span></label>
        <div><button type="button" className="cad-btn-primary" disabled={!consent} onClick={() => void begin()}>{t("WhatsApp ile doğrula")}</button></div>
      </>) : (
        <div className="grid grid-cols-[auto_1fr] gap-3 items-center">
          {qr ? <img src={qr} alt={t("WhatsApp doğrulama QR kodu")} width={150} height={150} /> : null}
          <div className="grid gap-1.5">
            <p>{t("WhatsApp açıldıysa hazır mesajı gönderin. Bilgisayardaysanız QR kodu telefonunuzla okutun.")}</p>
            <p>{t("Kod")}: <strong className="font-mono">{start.code}</strong> · {start.expiresInMinutes} {t("dk geçerli")}</p>
            <p className="text-cad-ink3">{t("Mesaj ulaşınca bu pencere kendiliğinden kapanır.")}</p>
            <div className="flex gap-1"><a href={start.url} target="_blank" rel="noopener noreferrer" className="cad-btn-box">{t("WhatsApp'ı aç")}</a><button type="button" className="cad-btn-box" onClick={() => void begin()}>{t("Yeni kod")}</button></div>
          </div>
        </div>
      )}
      {err ? <p role="alert">{err}</p> : null}
    </Dialog>
  );
}
